export default __webpack_public_path__ + "static/media/9.3bdd4d55.png";